// Registry of the Home module menu's user-orderable sections, in default
// order. Pure data (no components) so preference code can import it without
// dragging the section components along — `HomeModuleMenu` owns the
// id → Component mapping (typed by `HomeSectionId`, so the two can't
// drift). The fixed HomeNavSection ("nav") is pinned first by `HomeModuleMenu`
// and never appears here or in the Customize Navigation dialog.
export const HOME_SECTIONS = [
  { id: "favorites", label: "Favorites" },
  { id: "my-workflows", label: "My Workflows" },
  { id: "apps", label: "Apps" },
] as const;

export type HomeSectionId = (typeof HOME_SECTIONS)[number]["id"];

export const HOME_SECTION_IDS: readonly HomeSectionId[] = HOME_SECTIONS.map(
  (section) => section.id,
);
